import { createApp } from 'vue';
import { throttle } from 'throttle-debounce';

import axios from 'axios';
import VueAxios from 'vue-axios';

import URLHelper from './URLHelper';

/**
 * Бесконечная (до 10) загрузка новостей
 */

export default function vueInfinityNews() {
    const ELEMENTS = {
        el: '#infinity-news',
        newsItemEl: '.js-news-item',
        titleEl: '.page-title',
    };

    // В случае, если фронт запущен на локальном ПК,
    // подгружаются новости с локалки
    const API_NEWS_FETCH_URL = process.env.NODE_ENV === 'production'
            ? ' /api/public/content/media/news/nextnews/'
            : '/news-item-response.html';

    const mountWrapper = document.querySelector(ELEMENTS.el);
    if (mountWrapper) {
        createApp({
            data() {
                return {
                    offset: 80, // отступ для скрола, равный величине хедера
                    stopLoad: false, // true - останавливаем подгрузку новостей
                    stopIdx: 10, // лимит новостей - 14 шт, если подгрузка остановится раньше, меняем индекс
                    counter: 1, // какая по счёту новость выведена посленей
                    curIdx: 0, // индекс элемента из this.newsList, на котором мы сейчас находимся
                    newsList: [], // объекты всех новостей, выведенных на странице
                    firstId: 0,
                    container: null,
                    currentItem: null,
                };
            },
            beforeMount() {
                /*
                 * Возращение прокрутки наверх т.к. если пользователь перезагрузит
                 * страницу не из верхней границы скролла, то подгрузится сразу куча новостей
                 */
                window.history.scrollRestoration = 'manual';
            },
            mounted() {
                const firstElItem = document.querySelector(
                    `${ELEMENTS.newsItemEl}._first`,
                );
                this.firstId = firstElItem.dataset.id;
                this.container = this.$el;
                this.iblockCode = firstElItem.dataset.iblockCode;

                this.setItemInfo();
                [this.currentItem] = this.newsList;

                /* Выводим сразу 3 и 4 новость */
                this.getNextItem().then(() => {
                    this.getNextItem().then(() => {
                        this.getNextItem();
                    });
                });

                document.addEventListener(
                    'scroll',
                    throttle(150, this.scrollListener),
                );
            },
            methods: {
                /**
                 * Высчитывает высоту и отступ сверху для каждой новости
                 * Пушит все это в массив с новостями
                 */
                setItemInfo() {
                    const el = document.querySelector(
                        `[data-news-count="${this.counter}"]`,
                    );
                    if (!el) {
                        return false;
                    }

                    const elHeight = el.clientHeight;
                    const startPoint = el.offsetTop;
                    const newsTitle = el.querySelector(
                        ELEMENTS.titleEl,
                    )?.innerText;

                    this.newsList.push({
                        el,
                        height: elHeight,
                        startPoint,
                        endPoint: startPoint + elHeight,
                        href: el.dataset.href,
                        title: newsTitle,
                    });
                },

                /**
                 * Загружает следующую новость
                 */
                getNextItem() {
                    if (this.stopLoad) {
                        return false;
                    }

                    const requestParams = {
                        // id: this.newsList[this.counter - 1]?.el?.dataset?.id,
                        iblock_code: this.iblockCode,
                        first_id: this.firstId,
                        page: this.counter,
                    };

                    return this.axios
                        .get(API_NEWS_FETCH_URL, {
                            params: requestParams,
                        })
                        .then(({ data }) => {
                            const dataEl = this.stringToDOM(data);
                            this.addItemToNewsList(dataEl);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                },

                /**
                 * Добавляет новость в ДОМ
                 * и в массив новостей, если это необходимо
                 * @param newsItem {ChildNode}
                 */
                addItemToNewsList(newsItem) {
                    const newsItemEl = newsItem.querySelector('div');
                    if (!newsItemEl?.dataset?.href) {
                        console.error('news is empty');
                        this.stopLoad = true;
                        this.stopIdx = this.curIdx;
                        return false;
                    }

                    this.counter++;
                    // Добавление счетчика атрибутов счетчика и класса новостей
                    newsItemEl.dataset.newsCount = this.counter;
                    newsItemEl.classList.add('n-news-item-detail');
                    this.container.append(newsItemEl);
                    this.setItemInfo();

                    if (this.counter >= this.stopIdx) {
                        this.stopLoad = true;
                    }
                },

                /**
                 * Преобразует строку в HTML DOM внутри div
                 * @param str
                 * @return {ChildNode}
                 */
                stringToDOM(str) {
                    const dataToDOM = document.createElement('div');
                    dataToDOM.innerHTML = str.trim();

                    return dataToDOM.firstElementChild;
                },

                /**
                 * Возвращает урл и индекс к предыдущей новости
                 */
                switchBack() {
                    if (this.curIdx <= 0) return;
                    this.curIdx--;
                    this.setCurrentItem();
                },

                /**
                 * Задает новое значение для активного элемента
                 */
                setCurrentItem() {
                    this.currentItem = this.newsList[this.curIdx];
                    URLHelper.setURI(this.currentItem.href);

                    if (this.currentItem.title) {
                        document.title = this.currentItem.title;
                    }
                },

                /**
                 * Переключает урл и индекс к следующей новости
                 * Если необходимо, подгружает еще новости
                 */
                switchForward() {
                    if (this.curIdx + 3 > this.stopIdx) {
                        return;
                    }

                    this.curIdx++;
                    this.setCurrentItem();

                    if (!this.newsList[this.curIdx + 3]) {
                        this.getNextItem();
                    }
                },

                /**
                 * Обработчик скролла,
                 */
                scrollListener() {
                    if (window.pageYOffset < this.currentItem.startPoint) {
                        this.switchBack();
                    }

                    if (window.pageYOffset > this.currentItem.endPoint) {
                        this.switchForward();
                    }
                },
            },
        })
            .use(VueAxios, axios)
            .mount(ELEMENTS.el);
    }
}
